__turbopack_context__.v({
  "iconContainer": "search-bar-module-scss-module__xn6lkG__iconContainer",
  "input": "search-bar-module-scss-module__xn6lkG__input",
  "searching": "search-bar-module-scss-module__xn6lkG__searching",
  "submitButton": "search-bar-module-scss-module__xn6lkG__submitButton",
  "wrapper": "search-bar-module-scss-module__xn6lkG__wrapper",
});
